import { FormattedMessage } from 'react-intl';

export default function OAuthDivider() {
  return (
    <div className="relative">
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-slate-200" />
      </div>
      <div className="relative flex justify-center text-xs uppercase tracking-[0.2em] text-slate-400">
        <span className="bg-white/80 px-3">
          <FormattedMessage id="auth.oauth.divider" />
        </span>
      </div>
    </div>
  );
}
